export default __webpack_public_path__ + "static/media/pkt3.99b55b5b.svg";